export default __webpack_public_path__ + "c5b2589.png";